import { CSSTransition, SwitchTransition } from "react-transition-group";
import useInterval from "../../utils/useInterval";
import { useState } from "react";
import { ClientDeviceType, GameTip, apiService } from "@blacknut/javascript-sdk/dist";
import { usePlayerContext } from "../../utils/PlayerContext";
import { PlayerStatus } from "../../utils/PlayerUtils";
import styles from "./styles.module.scss";
import clsx from "clsx";
import { CircularProgress } from "@blacknut/react-sdk/dist";

interface TipsProps {
  launchTips?: GameTip[];
  className?: string;
}
export default ({ launchTips, className }: TipsProps) => {
  const { playerStatus } = usePlayerContext();
  const [tipIndex, setTipIndex] = useState(0);
  const launchTip = launchTips && launchTips[tipIndex];

  useInterval(
    () => {
      if (launchTips) {
        setTipIndex((tipIndex + 1) % launchTips.length);
      }
    },
    launchTips && playerStatus === PlayerStatus.INIT ? 5000 : null,
  );
  return (
    <>
      <div
        className={clsx(
          styles.container,
          apiService.userAgent.client === ClientDeviceType.TV && styles.tv,
          className,
        )}
      >
        <div className={styles.tip}>
          <div className={styles.imageContainer}>
            <div className={styles.separator} />
            <CircularProgress size={50} className={styles.spinner} />
            <div className={styles.separator} />
          </div>
          <SwitchTransition>
            <CSSTransition
              key={launchTip?.id || ""}
              addEndListener={(node: any, done: any) => {
                node.addEventListener("transitionend", done, false);
              }}
              classNames="fade"
            >
              <div className={styles.text}>
                <span>{launchTip?.text || ""}</span>
              </div>
            </CSSTransition>
          </SwitchTransition>
        </div>
      </div>
    </>
  );
};
